import { useQuery } from '@tanstack/react-query';

import getReportHostTasks from 'Api/report-host-tasks/getReportHostTasks';

import getReportHostTasksResponse from 'Domain/report-host-tasks/model/response/getReportHostTasksResponse';
import getReportHostTaskRequest from './model/request/getReportHostTaskRequest';

const useGetReportHostTasks = ({ filter, enabled }) => {
  return useQuery({
    queryKey: ['report-host-tasks', filter],
    queryFn: async () => {
      const payload = getReportHostTaskRequest(filter);

      const result = await getReportHostTasks(payload);

      const response = getReportHostTasksResponse(result);

      return response;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetReportHostTasks;
